module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C829"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents ")])])]), _vm._v(" "), _c('p', {
    staticClass: "P34"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_List_of#page_ix"
    }
  }, [_vm._v("List of Tables and Figures ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_Preface#page_xi"
    }
  }, [_vm._v("Preface ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('a', {
    attrs: {
      "href": "#/html/08_Acknowle#page_xvii"
    }
  }, [_vm._v("Acknowledgments ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('a', {
    attrs: {
      "href": "#/html/09_Introduc#page_1"
    }
  }, [_vm._v("Introduction: Welcome to Venice ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_CHAPTER#page_19"
    }
  }, [_vm._v("CHAPTER 1. A Beach Town in Transition ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_CHAPTER#page_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2. The Transformation of a Black Neighborhood ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_CHAPTER#page_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3. People out of Place ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_CHAPTER#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4. Scenic Neighborhood ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_CHAPTER#page_164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5. Bohemian Theme Park ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_CHAPTER#page_204",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6. Fashionable Bohemia ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_CHAPTER#page_235",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7. The Future of the American City ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_Notes#page_251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_Bibliogr#page_283",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography ")])]), _vm._v(" "), _c('p', {
    staticClass: "P35"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_Index#page_301",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5573e025","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Contents.vue
// module id = 66
// module chunks = 0